
// region JS Imports

// region External Modules
import $ from "jquery"
import { EventEmitter } from "events"
// endregion External Modules

// region Private Modules
import {
  onClickOutside,
} from "plugins/vanilla-clickout"
// endregion Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


interface Selector {
  scope:           string
  main:            string
  menu:            string
  toggle:          string
  dropdown_label:  string

  economic_indicator_comparison_option: string
}

interface InputSelector {
  scope?:           string
  main?:            string
  menu?:            string
  toggle?:          string
  dropdown_label?:  string

  economic_indicator_comparison_option?: string
}

const DEFAULT_SELECTOR = {
  scope:          ".page--building-level-real-estate-transactions-page--compare-section-desktop",
  main:           ".page--building-level-real-estate-transactions-page--compare-section-desktop-economic-indicator-comparison",
  menu:           ".page--building-level-real-estate-transactions-page--compare-section-desktop-economic-indicator-comparison-dropdown",
  toggle:         ".page--building-level-real-estate-transactions-page--compare-section-desktop-economic-indicator-comparison-toggle",
  dropdown_label: ".page--building-level-real-estate-transactions-page--compare-section-desktop-economic-indicator-comparison-toggle-text",

  economic_indicator_comparison_option: ".page--building-level-real-estate-transactions-page--compare-section-desktop-economic-indicator-comparison-option",
}


class EconomicIndicatorComparisonSelectMenu extends EventEmitter {
  protected selector: Selector

  protected $scope:           JQuery
  protected $main:            JQuery
  protected $menu:            JQuery
  protected $toggle:          JQuery
  protected $dropdown_label:  JQuery

  protected $economic_indicator_comparison_option:  JQuery


  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)

    this.$scope = $(this.selector.scope)
    this.$main = this.$scope.find(this.selector.main)
    this.$menu = this.$scope.find(this.selector.menu)
    this.$toggle = this.$main.find(this.selector.toggle)
    this.$dropdown_label = this.$main.find(this.selector.dropdown_label)

    this.$economic_indicator_comparison_option = this.$scope.find(this.selector.economic_indicator_comparison_option)

    this.bind_action()
  }

  protected updateButtonStyle(){
    if ( this.selected_value() === "none" ) {
      this.$main.removeClass("with-data--selected")
    }
    else {
      this.$main.addClass("with-data--selected")
    }
  }

  protected bind_action(){
    this.$toggle.on("click", () => {
      if ( this.$main.hasClass("disabled") ) {
        return
      }

      if ( this.$menu.hasClass("active") ) {
        this.$menu.removeClass("active")
      }
      else {
        this.$menu.addClass("active")
      }
    })

    this.$economic_indicator_comparison_option.on("click", (e) => {
      this.$menu.removeClass("active")

      if ( $(e.currentTarget).hasClass("selected") && this.$main.hasClass("with-data--selected") ) {
        return
      }

      this.$economic_indicator_comparison_option.removeClass("selected")
      $(e.currentTarget).addClass("selected")

      this.updateButtonStyle()
      this.emit("val_change")
    })

    onClickOutside(this.$main[0] as HTMLElement, () => {
      this.$menu.removeClass("active")
    })
  }

  public selected_value() {
    return this.$economic_indicator_comparison_option.filter(".selected").attr("data") as string
  }

  public is_selected() {
    return this.$main.hasClass("with-data--selected")
  }

  public reset() {
    this.$main.removeClass("with-data--selected")

    this.$economic_indicator_comparison_option.removeClass("selected")
    this.$economic_indicator_comparison_option.filter("[data=none]").addClass("selected")

    this.$dropdown_label.removeClass("with-data--selected")
    this.$toggle.find("i").show()
  }

}

const Factory = {
  _instance: null as null | EconomicIndicatorComparisonSelectMenu,

  instance(selector?: InputSelector){
    if (this._instance != null) { return this._instance }

    this._instance = this.create(selector)
    return this._instance
  },
  create(selector?: InputSelector){
    return new EconomicIndicatorComparisonSelectMenu(selector)
  },
}

export {
  Factory,
  EconomicIndicatorComparisonSelectMenu,
}
